import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Loader2, X } from 'lucide-react';

export function NewsletterSubscriberDialog({ editingSub, setEditingSub, savingSub, onSave }) {
  return (
      <Dialog open={!!editingSub} onOpenChange={(o) => { if (!o) setEditingSub(null); }}>
        <DialogContent className="max-w-md" data-testid="newsletter-subscriber-dialog">
          <DialogHeader>
            <DialogTitle>Éditer l'abonné</DialogTitle>
            <DialogDescription>{editingSub?.email}</DialogDescription>
          </DialogHeader>
          {editingSub && (
            <div className="space-y-3">
              <div>
                <Label>Nom</Label>
                <Input
                  value={editingSub.name}
                  onChange={(e) => setEditingSub({ ...editingSub, name: e.target.value })}
                  data-testid="newsletter-subscriber-field-name"
                />
              </div>
              <div>
                <Label>Territoire</Label>
                <Input
                  placeholder="ex. Guadeloupe, Martinique, Réunion…"
                  value={editingSub.territoire}
                  onChange={(e) => setEditingSub({ ...editingSub, territoire: e.target.value })}
                  data-testid="newsletter-subscriber-field-territoire"
                />
              </div>
              <div>
                <Label>Tags</Label>
                <div className="flex flex-wrap gap-1 mb-1" data-testid="newsletter-subscriber-tags-display">
                  {(editingSub.tags || []).map((t) => (
                    <span key={t} className="px-2 py-0.5 text-[11px] rounded-full bg-emerald-100 text-emerald-800 border border-emerald-300 inline-flex items-center gap-1">
                      {t}
                      <button type="button" onClick={() => setEditingSub({ ...editingSub, tags: editingSub.tags.filter((x) => x !== t) })} className="hover:text-red-700">×</button>
                    </span>
                  ))}
                </div>
                <Input
                  placeholder="Ajouter un tag (Entrée)"
                  value={editingSub._tagInput || ''}
                  onChange={(e) => setEditingSub({ ...editingSub, _tagInput: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      const v = (editingSub._tagInput || '').trim();
                      if (v && !editingSub.tags.includes(v)) {
                        setEditingSub({ ...editingSub, tags: [...editingSub.tags, v], _tagInput: '' });
                      }
                    }
                  }}
                  data-testid="newsletter-subscriber-field-tag-input"
                />
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditingSub(null)} data-testid="newsletter-subscriber-dialog-cancel">
              Annuler
            </Button>
            <Button onClick={onSave} disabled={savingSub} className="bg-emerald-700 hover:bg-emerald-800" data-testid="newsletter-subscriber-dialog-save">
              {savingSub ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : null}
              Enregistrer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
}
